/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1TutoraiConfigPersona202,
  PutApiV1TutoraiConfigPersona400,
  PutApiV1TutoraiConfigPersona401,
  PutApiV1TutoraiConfigPersona500,
  PutApiV1TutoraiConfigPersonaMutationRequest,
  PutApiV1TutoraiConfigPersonaMutationResponse,
} from "../../types/tutorAIConfigController/PutApiV1TutoraiConfigPersona.ts";
import { tutorAISetPromptConfigViewModelSchema } from "../tutorAISetPromptConfigViewModelSchema.ts";

/**
 * @description (Accepted) Requisição aceita.
 */
export const putApiV1TutoraiConfigPersona202Schema =
  z.any() as unknown as ToZod<PutApiV1TutoraiConfigPersona202>;

/**
 * @description Conteúdo vazio.
 */
export const putApiV1TutoraiConfigPersona400Schema =
  z.any() as unknown as ToZod<PutApiV1TutoraiConfigPersona400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1TutoraiConfigPersona401Schema =
  z.any() as unknown as ToZod<PutApiV1TutoraiConfigPersona401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1TutoraiConfigPersona500Schema =
  z.any() as unknown as ToZod<PutApiV1TutoraiConfigPersona500>;

export const putApiV1TutoraiConfigPersonaMutationRequestSchema = z.lazy(
  () => tutorAISetPromptConfigViewModelSchema,
) as unknown as ToZod<PutApiV1TutoraiConfigPersonaMutationRequest>;

export const putApiV1TutoraiConfigPersonaMutationResponseSchema = z.lazy(
  () => putApiV1TutoraiConfigPersona202Schema,
) as unknown as ToZod<PutApiV1TutoraiConfigPersonaMutationResponse>;
